import React from "react";
import "../../../assets/css/user/sellerBanner/SellerBanner.css";
import { useNavigate } from "react-router-dom";


const CheckIcon = () => (
  <svg
    className="check-icon"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="9.5" stroke="white" strokeWidth="1.6" />
    <path
      d="M6.5 11l3 3 6-6"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StoreIcon = () => (
  <svg
    className="store-svg"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 34 L15 18 H65 L70 34"
      stroke="white"
      strokeWidth="3"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M10 34 Q20 42 30 34 Q40 26 50 34 Q60 42 70 34"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
    <rect x="12" y="34" width="56" height="30" rx="2" stroke="white" strokeWidth="3" fill="none" />
    <path
      d="M31 64 V50 Q31 46 35 46 H45 Q49 46 49 50 V64"
      stroke="white"
      strokeWidth="3"
      strokeLinejoin="round"
      fill="none"
    />
    <rect x="15" y="18" width="50" height="5" rx="2" stroke="white" strokeWidth="2.5" fill="none" />
  </svg>
);

const SellerBanner = () => {
   const navigate = useNavigate();
  return (
    <div className="page-wrapper">
      <div className="banner">
        <div className="bg-circle bg-circle--top-right" />
        <div className="bg-circle bg-circle--bottom-mid" />

        <div className="banner__content">
          <h2 className="banner__title">Become a Seller on Time4Pulse</h2>
          <p className="banner__subtitle">
            Have unused appointment slots? Turn them into revenue! List your services
            as instant deals and reach thousands of customers instantly.
          </p>

          <ul className="banner__list">
            <li><CheckIcon /> Free to register</li>
            <li><CheckIcon /> List deals in minutes</li>
            <li><CheckIcon /> Get paid instantly</li>
            <li><CheckIcon /> KYC verified trust badge</li>
          </ul>

             <button
            className="banner__btn"
            onClick={() => navigate("/seller-signup")}
          >
            Signup as Seller <span className="banner__btn-arrow">→</span>
          </button>
        </div>

        <div className="banner__icon-area">
          <div className="banner__icon-circle">
            <StoreIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerBanner;